<script>
    import StringsLayoutCreator from './StringsLayoutCreator';
    import openModal from '../buttons/openModal';
    import StringsLayoutsListRow from './StringsLayoutsListRow';

    export default {

        components: {
            StringsLayoutCreator,
            openModal,
            StringsLayoutsListRow
        },

        provide() {
            return {
                StringsLayoutsListState: this.sharedState
            }
        },

        data() {
            return {
                table: new Table({
                    stringsLayouts: '',
                }),
                isActive: false,
                filter: 'current',
                sharedState: {
                    activeItem: '',
                    targetItem: {}
                }
            }

        },

        created() {
            this.fetch();
        },

        methods: {
            fetch() {
                this.table.stringsLayouts = {};
                axios.get(`/strings-layouts?status=${this.filter}`)
                    .then(({data}) => {
                        this.table.stringsLayouts = _.orderBy(data, 'harp.nome', 'asc');
                        this.sharedState.activeItem = this.table.stringsLayouts[0].id;
                    });
            },

            orderBy(key, ord = 'asc') {
                this.table.stringsLayouts = _.orderBy(this.table.stringsLayouts, key, ord)
            },

            toggleItemCreator() {
                this.isActive = !this.isActive;
            }
        }

    }
</script>